export default __webpack_public_path__ + "static/onjoin-410234d255004102267548e4cb43a8bf.png";